import { apiClient } from './api'

const legalAdminService = {
  async listDocuments() {
    const response = await apiClient.get('/admin/legal/documents')
    return response.data?.data ?? []
  },

  async createDocument(payload) {
    const response = await apiClient.post('/admin/legal/documents', payload)
    return response.data?.data ?? response.data
  },

  async listVersions(documentId) {
    const response = await apiClient.get(`/admin/legal/documents/${documentId}/versions`)
    return response.data?.data ?? []
  },

  async createDraft(documentId, payload) {
    const response = await apiClient.post(`/admin/legal/documents/${documentId}/versions`, payload)
    return response.data?.data ?? response.data
  },

  async updateDraft(versionId, payload) {
    const response = await apiClient.patch(`/admin/legal/versions/${versionId}`, payload)
    return response.data?.data ?? response.data
  },

  async publishVersion(versionId) {
    const response = await apiClient.post(`/admin/legal/versions/${versionId}/publish`)
    return response.data?.data ?? response.data
  },

  async archiveVersion(versionId) {
    const response = await apiClient.post(`/admin/legal/versions/${versionId}/archive`)
    return response.data?.data ?? response.data
  },

  async getAcceptanceStats(versionId) {
    const response = await apiClient.get(`/admin/legal/versions/${versionId}/acceptance-stats`)
    return response.data?.data ?? null
  },
}

export default legalAdminService
